class EventBuffer extends Array {
  constructor() {
    super();
  }

  isEmpty() {
    return this.length === 0;
  }

  isFull() {
    return this.length === 10;
  }

  flush() {
    return this.splice(0, this.length);
  }
}

export default EventBuffer;
